import React from 'react';
import { IndexCoordinatorDelegate } from "../IndexCoordinator";
import { ImmobileSituationViewControllerDelegate, ImmobileSituationViewController } from "../../Screen/ImmobileSituation/ImmobileSituationViewController";
import { TableGenericViewControllerDelegate, TableGenericViewController } from "../../Screen/TableGeneric/TableGenericViewController";
import { TableGenericViewModel } from "../../Screen/TableGeneric/TableGenericViewModel";
import { ImmobileSituationViewModel } from '../../Screen/ImmobileSituation/ImmobileSituationViewModel';
import ProtectedRoute from '../../Components/ProtectedRoute';

export class ImmobileSituationCoordinator implements IndexCoordinatorDelegate, ImmobileSituationViewControllerDelegate, TableGenericViewControllerDelegate {
    
    getRoute(): JSX.Element[] {
        return [
            this.routeTableSituation(),
            this.routeFormSituation()
        ]
    }

    private routeTableSituation(): JSX.Element {
        var viewModel = new TableGenericViewModel("gepsituacoesshape")
        return (<ProtectedRoute requiredPermissions={['info_bas.sit_imovel.*']} path="/:base/situacao-imovel" exact={true} component={(props: any) => {
            return (<TableGenericViewController
                permissions={{
                    add: 'info_bas.sit_imovel.adicionar',
                    edit: 'info_bas.sit_imovel.editar',
                    delete: 'info_bas.sit_imovel.excluir',
                }} 
                navigation={props} 
                viewModel={viewModel} 
                delegate={this} 
                title={"Situação Imóvel"}
            />)
        }}/>)
    }

    private routeFormSituation(): JSX.Element {
        var viewModel = new ImmobileSituationViewModel()
        return (<ProtectedRoute requiredPermissions={['info_bas.sit_imovel.adicionar', 'info_bas.sit_imovel.editar']} path="/:base/situacao-imovel/cad/:id" exact={true} component={(props: any) => {
            var idPk = props.match.params.id
            return (<ImmobileSituationViewController navigation={props} viewModel={viewModel} delegate={this} idPrimary={idPk}/>)
        }}/>)
    }

    tapDimiss(navigation: any): void {
        navigation.history.goBack();
    }
    
    add(navigation: any, viewModel: TableGenericViewModel): void {
        if(viewModel.getTable() == "gepsituacoesshape") {
            navigation.history.push(`situacao-imovel/cad/0`);
            return;
        }
    }

    edit(navigation: any, idSelection: number, viewModel: TableGenericViewModel): void {
        if(viewModel.getTable() == "gepsituacoesshape") {
            navigation.history.push(`situacao-imovel/cad/${idSelection}`);
            return;
        }
    }

}